import http from "./httpService";
const apiUrl = require("../config.json").apiUrl;
const refundApiUrl = require("../config.json").refundApiUrl;
// import  apiUrl from ".././config.json";

export const getbookingDetails = (data) => {
    const apiEndPoint = `${apiUrl}/BookingDetailsBasedOnUserId`;
    return http.post(`${apiEndPoint}`,data);
  };


  export const GetCancellationReasons = (data) => {
    const apiEndPoint = `${apiUrl}/ConfigMstrList/Type`;
    return http.post(`${apiEndPoint}`,data);
};

export const getSingleBookingIdDetails = (data) => {
  const apiEndPoint = `${apiUrl}/BookingDetailsBasedOnBookingId`;
  return http.post(`${apiEndPoint}`,data);
};


export const getSingleCancellationDetails = (data) => {
  const apiEndPoint = `${apiUrl}/PublicAndDepartmentBookingCancellationDetails`;
  return http.post(`${apiEndPoint}`,data);
};


export const getGstData=(data)=>{
  const apiEndPoint = `${apiUrl}/TaxMstr/IdDate`;
  return http.post(`${apiEndPoint}`,data); 
}



export const getCancellationChargesDetails = (data) => {
  const apiEndPoint = `${apiUrl}/CancellationNoteDetails`;
  return http.post(`${apiEndPoint}`,data);
};

export const CancellationUpdate = (data) => {
  const apiEndPoint = `${apiUrl}/CancellationUpdate`;
  return http.post(`${apiEndPoint}`,data);
};
export const CancellationRefundUpdate = (data) => {
  const apiEndPoint = `${refundApiUrl}/RefundRequestPublic`;
  return http.post(`${apiEndPoint}`,data);
};

export const getCancellationHistory = (data) => {
  const apiEndPoint = `${apiUrl}/PublicBookingHistory`;
  return http.post(`${apiEndPoint}`,data);
};

export const getBookedOtherService = (data) => {
  // to check reschedule available on selected date
  const apiEndPoint = `${apiUrl}/BookingReschedule/RescheduleDetails`;
  return http.post(`${apiEndPoint}`, data);
};